import { observer } from 'mobx-react-lite'
import React, { useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CancelButton, RemoveButton } from '../../components'
import { StoreContext } from '../../store'
import { AppModal } from '../general/AppModal'
import { ResponsiveBody } from '../typography/ResponsiveBody'

interface IProps {
  visible: boolean
  onClose: () => void
}

const OrgDialogContentComponent: React.FC<IProps> = ({ onClose, visible }) => {
  const { t } = useTranslation()
  const { orgStore, userStore } = useContext(StoreContext)
  const { removeOrg } = userStore
  const { setShowModal, setLeavingOrg } = orgStore

  const handleRemove = useCallback(() => {
    setShowModal(false)
    removeOrg(orgStore.leavingOrg)
    setLeavingOrg('')
  }, [orgStore.leavingOrg, removeOrg, setLeavingOrg, setShowModal])

  const handleModalCancel = useCallback(() => setShowModal(false), [setShowModal])

  return (
    <AppModal
      id="leave_organization_modal"
      isOpen={visible}
      title={t('myOrgsView.modalTitle')}
      onClose={onClose}
      controls={
        <>
          <CancelButton type="button" id="cancel_leave_button" onClick={handleModalCancel} />
          <RemoveButton type="button" id="leave_organization_button" onClick={handleRemove} />
        </>
      }
    >
      <ResponsiveBody>{t(`myOrgsView.modalText`)}</ResponsiveBody>
    </AppModal>
  )
}

export const OrgDialogContent = observer(OrgDialogContentComponent)
